

















import BaseComponent from '@/components/base-component.vue';
import UiPrescriptionButtonImpeditive from '@/components/UI/prescription-button/impeditive.vue';
import UiPrescriptionButtonInvalid from '@/components/UI/prescription-button/invalid.vue';
import UiPrescriptionButtonLoading from '@/components/UI/prescription-button/loading.vue';
import UiPrescriptionButtonOk from '@/components/UI/prescription-button/ok.vue';
import UiPrescriptionButtonWarning from '@/components/UI/prescription-button/warning.vue';
import { PrescriptionValidation } from '@/settings/consts/prescription-validation';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ValidationMessagesDialog from './validation-messages-dialog.vue';

@Component({
  components: {
    UiPrescriptionButtonWarning,
    UiPrescriptionButtonInvalid,
    UiPrescriptionButtonImpeditive,
    UiPrescriptionButtonLoading,
    UiPrescriptionButtonOk,
    ValidationMessagesDialog,
  },
})
export default class PrescriptionFormSaveArea extends BaseComponent {
  @Prop()
  public prescriptionState: any;
  @Prop()
  public validationError?: boolean;
  @Prop()
  public isTranscription?: boolean;
  @Prop()
  public quantidade?: number;
  @Prop()
  public patientType?: any;
  @Prop()
  public validationMessages: any[];

  validationMessagesPopin = []
  showValidationMessagesPopin = false;


  public labelSave(label: string = ''): string {
    let msg = '';
    if (this.isTranscription) {
      msg += `Salvar Transcrição `;
    } else {
      msg += `Salvar Prescrição `
    }
    if (this.patientType) {
      msg += 'para ' + this.patientType.texto + ' ';
    }
    msg += label;
    if (this.quantidade && this.quantidade > 1) {
      msg += ' ( ' + this.quantidade + ' Unidades )';
    }
    return msg;
  }

  public onClick() {
    if (this.validationMessages) {
      let msgsPopin = this.validationMessages.filter(m => m.solicitarCiente);
      if (msgsPopin.length) {
        this.validationMessagesPopin = msgsPopin;
        this.showValidationMessagesPopin = true;
        return;
      }
    }
    this.$emit('save');
  }

  public save() {
    this.showValidationMessagesPopin = false;
    this.$emit('save');
  }

  public cancel() {
    this.showValidationMessagesPopin = false;
  }

  public isOK(): boolean {
    return this.prescriptionState === PrescriptionValidation.OK.key;
  }

  public isTyping(): boolean {
    return this.prescriptionState === PrescriptionValidation.TYPING.key;
  }

  public isLoading(): boolean {
    return this.prescriptionState === PrescriptionValidation.LOADING.key;
  }

  public isImpeditive(): boolean {
    return this.prescriptionState === PrescriptionValidation.IMPEDITIVE.key;
  }

  public isInvalid(): boolean {
    return this.prescriptionState === PrescriptionValidation.INVALID.key;
  }

  public isAlert(): boolean {
    return this.prescriptionState === PrescriptionValidation.ALERT.key;
  }
}
